import $ from 'jquery';
export default {
    name: 'confirm-fin-consultation',
    components: {},
    props: [],
    data() {
        return {
            checked: false,
            loading: false,
        }
    },
    computed: {
        patient() {
            return this.$store.getters['patient']
        },
        consultationEnCours() {
            return this.$store.getters['consultationPatientEnCours']
        }

    },
    mounted() {

    },
    methods: {
        endConsultation() {
            if (this.checked === false) {
                $('.err-msg').fadeIn()
            } else {
                this.loading = true
                this.$store.dispatch("endConsultation", { consultation_id: this.consultationEnCours.id, date_rdv_to_send: '' }).then((response) => {
                    console.log(response)
                    this.loading = false
                    this.$refs.modalEndConsultation.click()
                    this.$router.push({ "path": "/dashboard" })
                })
            }

        },

        changedChecked() {
            if (this.checked === true) {
                $('.err-msg').fadeOut()
            }
        }
    }
}


